(() => {
  'use strict';

  // STOPPA ALLT på /cart (förhindrar loop)
  if (window.location.pathname === '/cart') return;

  const STORAGE_KEY = 'selectedDiscountCode';

  // anti-loop / anti-spam
  const recentlySubmitted = new WeakMap(); // form -> timestamp
  const lastAppliedCode = new WeakMap();   // form -> code

  function now() {
    return Date.now();
  }

  function getCode() {
    try {
      return (sessionStorage.getItem(STORAGE_KEY) || '').trim();
    } catch (e) {
      return '';
    }
  }

  // ✅ Viktigt: bara drawerns discount-form
  function findDrawerDiscountForms(root = document) {
    return Array.from(
      root.querySelectorAll('form[is="cart-discount"][data-section-id*="__cart-drawer"]')
    );
  }

  function hasDiscountApplied(form, code) {
    if (!code) return false;
    return !!form.querySelector(
      `button[is="discount-remove"][data-discount="${CSS.escape(code)}"]`
    );
  }

  function clickRemove(form, code) {
    if (!code) return false;
    const btn = form.querySelector(
      `button[is="discount-remove"][data-discount="${CSS.escape(code)}"]`
    );
    if (!btn) return false;
    btn.click();
    return true;
  }

  function setNativeValue(input, value) {
    const proto = Object.getPrototypeOf(input);
    const desc = Object.getOwnPropertyDescriptor(proto, 'value');
    if (desc?.set) desc.set.call(input, value);
    else input.value = value;

    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function safeApply(form) {
    const last = recentlySubmitted.get(form) || 0;
    if (now() - last < 1200) return;
    recentlySubmitted.set(form, now());

    // ✅ klicka “Tillämpa” istället för submit/requestSubmit (temat brukar lyssna på klick)
    const btn = form.querySelector('button[type="submit"]');
    if (btn) btn.click();
  }

  function applyDiscount(form, code) {
    if (!code) return;

    // redan aktiv -> klart
    if (hasDiscountApplied(form, code)) {
      lastAppliedCode.set(form, code);
      return;
    }

    // om vi nyss försökte samma kod -> gör inget
    if (lastAppliedCode.get(form) === code) return;

    const input = form.querySelector('input[name="discount"]');
    if (!input) return;

    setNativeValue(input, code);
    lastAppliedCode.set(form, code);
    safeApply(form);
  }

  function syncDrawerDiscount() {
    const code = getCode();
    const forms = findDrawerDiscountForms();
    if (!forms.length) return;

    forms.forEach((form) => {
      if (!code) {
        // rensa bara våra koder
        clickRemove(form, 'GRON1');
        clickRemove(form, 'GRON2');
        lastAppliedCode.delete(form);
        return;
      }

      // växling 1<->2: rensa den andra
      const other = code === 'GRON1' ? 'GRON2' : 'GRON1';
      clickRemove(form, other);

      applyDiscount(form, code);
    });
  }

  // debounce
  let t = null;
  function scheduleSync() {
    clearTimeout(t);
    t = setTimeout(syncDrawerDiscount, 200);
  }

  function bind() {
    // kör när du ändrar val i blocket
    window.addEventListener('green_deduction:changed', scheduleSync);

    // kör när drawern öppnas (klick på kundvagn-ikon m.m.)
    document.addEventListener(
      'click',
      (e) => {
        const el = e.target?.closest?.('a,button');
        if (!el) return;

        const opensCart =
          el.matches('[href="/cart"], [href^="/cart?"], [aria-controls*="cart"], [data-open-cart], [data-cart-drawer-open]') ||
          (el.getAttribute('aria-label') || '').toLowerCase().includes('kundvagn');

        if (opensCart) {
          setTimeout(scheduleSync, 250);
          setTimeout(scheduleSync, 900);
        }
      },
      true
    );

    // kör när drawern renderas/uppdateras via sections/AJAX
    const mo = new MutationObserver(() => scheduleSync());
    mo.observe(document.body, { childList: true, subtree: true });

    // initialt (om drawer redan finns)
    scheduleSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();